import { faFilePdf, faMoneyBill, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import ConfigService from "../../../services/configuracion/ConfigService";
import ButtonLink from "../../generico/ButtonLink";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import history from "../login/history";
import TarjetaCreditoAdicionalPopup from "./TarjetaCreditoAdicionalPopup";
import { ModalPinTransaccional } from "../../generico/ModalPinTransaccional";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

const PAGAR_TARJETA = 67;
const tokenActivo = sessionStorage.getItem('tieneToken');

const DetalleFila = ({ data }) => (
  <div className="row" style={{ margin: 0, fontSize: 13, marginBottom: 20 }}>
    <div className="col-md-12">
      <p style={{ fontWeight: 500, marginBottom: 0 }}>Detalles:</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Pago Mínimo: {data.pagoMinimo}</p>
    </div>
    <div className="col-md-3">
      <p style={{ marginBottom: 0 }}>Saldo Plan: {data.saldoPlan}</p>
    </div>
    <div className="col-md-3">
      <p style={{ marginBottom: 0 }}>Deuda Total: {data.deudaTotal}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Saldo Mora: {data.saldoMora}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Días Mora: {data.diasMora}</p>
    </div>
  </div>
);

export default class TarjetaCredito extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tarjetaAdicionalList: [],
      tarjetaTitular: undefined,
    }
    this.selectorValuePopUp = this.selectorValuePopUp.bind(this);
    this.receiveMessageFromIframe = this.receiveMessageFromIframe.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMessageFromIframe);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessageFromIframe);
  }

  receiveMessageFromIframe(event) {
    sessionStorage.setItem("ORIGIN", event.origin);
  }

  pagarTarjeta = (url, row) => {
    //console.log(row);
    sessionStorage.setItem("resumen", row.nroTC);
    sessionStorage.setItem("tipo", row.tipo);
    sessionStorage.setItem("deuda", row.deudaTotal);
    sessionStorage.setItem("datosTarjeta", JSON.stringify(row));
    history.push(url);
    window.location.reload();

  }

  verExtracto = (url, row) => {
    sessionStorage.setItem("nroTarjeta", row.nroTC);
    sessionStorage.setItem("resumen", row.nroTC);
    sessionStorage.setItem("tipo", row.tipo);
    sessionStorage.setItem("cuenta", row.cuenta);
    history.push(url);
    window.location.reload();
  }

  pinVirtualcrear = (action, key) => {
    this.limpiarStorage();
    sessionStorage.setItem('ACTION', action);
    sessionStorage.setItem('numeroTC', key.nroTC);
    history.push(ConfigService.getPathByName('crearPinVirtual')?.url);
    window.location.reload();
  }

  limpiarStorage() {
    sessionStorage.removeItem('PASO2');
    sessionStorage.removeItem('PASO3');
    sessionStorage.removeItem('numeroTC');
    sessionStorage.removeItem('PARAMETRO');
    sessionStorage.removeItem('PARAMETRO2');
  }

  configurarTarjetaCabal = (row) => {

    let tarjetaSeleccionada = [
      {
        nroTC: this.formateoTarjeta(row.nroTC),
        nroTarjetaMaster: this.formateoTarjetaMaster(row.nroTC),
        linea: row.linea + " GS.",
        tipo: row.tipo + " " + this.formateoTarjeta(row.nroTC),
        tarjetaURL: this.obtenerImagenTarjeta(row.nroTC),
        cuenta: row.cuenta,
        tipoDesc: row.tipo,
        nroTarjetaCompleto: row.nroTC
      }
    ];

    sessionStorage.setItem("tarjetaSeleccionada", JSON.stringify(tarjetaSeleccionada[0]));
    history.push(ConfigService.getPathByName("configurarTarjetaCabal")?.url);
    window.location.reload();

  }

  configurarTarjeta = (row) => {

    let tarjetaSeleccionada = [
      {
        nroTC: this.formateoTarjeta(row.nroTC),
        nroTarjetaMaster: this.formateoTarjetaMaster(row.nroTC),
        linea: row.linea + " GS.",
        tipo: row.tipo + " " + this.formateoTarjeta(row.nroTC),
        tarjetaURL: this.obtenerImagenTarjeta(row.nroTC),
        cuenta: row.cuenta,
        tipoDesc: row.tipo,
        nroTarjetaCompleto: row.nroTC
      }
    ];

    let list = row.tarjetasAdicionales?.map(tarjeta => (
      {
        nroTC: this.formateoTarjeta(tarjeta.nroTarjeta),
        nroTarjetaMaster: this.formateoTarjetaMaster(tarjeta.nroTarjeta),
        linea: formatoSeparadorMilesValue(tarjeta.linea) + " GS.",
        tipo: row.tipo + " " + this.formateoTarjeta(tarjeta.nroTarjeta),
        tarjetaURL: this.obtenerImagenTarjeta(tarjeta.nroTarjeta),
        cuenta: tarjeta.cuenta,
        tipoDesc: row.tipo,
        nroTarjetaCompleto: tarjeta.nroTarjeta
      }
    ));

    this.setState({ tarjetaAdicionalList: list, tarjetaTitular: tarjetaSeleccionada });
    // si posee tarjeta adicionales llamar al modal
    if (list?.length > 0) {
      this.modalControl.click();
    } else {
      sessionStorage.setItem("tarjetaSeleccionada", JSON.stringify(tarjetaSeleccionada[0]));
      history.push(ConfigService.getPathByName("configurarTarjeta")?.url);
      window.location.reload();
    }
  }

  selectorValuePopUp = (tarjetaSeleccionada) => {
    sessionStorage.setItem("tarjetaSeleccionada", JSON.stringify(tarjetaSeleccionada));
    //history.push('/configurarTarjeta');
    history.push(ConfigService.getPathByName("configurarTarjeta")?.url);
    window.location.reload();
  };

  obtenerImagenTarjeta(nroTarjeta) {
    var prefijo = nroTarjeta.substring(0, 4);
    if (prefijo === "5150" || prefijo === "5418") {
      return "dist/img/credit/master-clasica.png";
    }
    if (prefijo === "5358" || prefijo === "5402") {
      return "dist/img/credit/master-oro.png";
    }
    if (prefijo === "6020") {
      return "dist/img/credit/panal.png";
    }
    if (prefijo === "5896" || prefijo === "6042") {
      return "dist/img/credit/cabal.png";
    }
  }
  formateoTarjeta(nroTarjeta) {
    return nroTarjeta.substring(0, 4) + " **** **** " + nroTarjeta.substring(nroTarjeta.length - 4, nroTarjeta.length)
  }
  formateoTarjetaMaster(nroTarjeta) {
    return nroTarjeta.substring(0, 6) + "******" + nroTarjeta.substring(nroTarjeta.length - 4, nroTarjeta.length)
  }

  ocultarMenuDinamico(tipoValidacion) {
    if (tipoValidacion === 'pinVirtual') {
      return ConfigService.getPathByName('crearPinVirtual') === null ?
        { display: 'none' } : { marginBottom: 5, paddingTop: 5, textAlign: "right" };
    }
  }

  render() {
    return (

      <div>
        { 
          tokenActivo === "N" &&
          <div className="col-12">
            <div className="card card-aviso-completo">
              <div className="card-header card-aviso">
                <h3 className="title-aviso" >Estimado Socio:</h3>
              </div>
              <div className="card-body">
                <p>Recuerde que firmar el Contrato Único y gestionar su Token, le permitirá acceder a mayores 
                beneficios y seguridad en sus transacciones. Le esperamos en cualquiera de nuestras Sucursales.</p>
              </div>
            </div>
          </div>
        }
        {
          this.props.tc.length === 0
            ?
            <p className="p-4 text-center">{this.props.mensajeSinTarjetas}</p>
            :
            this.props.tc.map((key, index) => {
              return (
                <div key={index} className="row tarjetas" style={{ border: "1px solid #ddd", marginLeft: 1, marginRight: 1 }}>
                  <div className="col-md-6" style={{ paddingLeft: 15 }}>

                    <div className="row">
                      <div className="col-md-5 tarjeta-align">
                        <span className="dato" style={{ fontSize: 20, fontWeight: "bold" }}>{key.tipo} {key.nroTarjeta}</span>
                        <div className="tarjeta-imagen" style={{ padding: "15px 0px 0px 0px" }}>
                          <img src={key.tarjetaURL} width="90%" height="100%" />
                        </div>
                      </div>
                      <div className="col-md-7 tarj2" style={{ fontWeight: 500 }}>
                        <div className="container">
                          <div className="row" style={{ paddingTop: 15 }}>

                            <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                              <label className="titulo">Línea:</label>
                              <p className="dato" style={{ fontWeight: 500 }}>{key.linea} GS.</p>

                            </div>
                              <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                                <label className="titulo">Saldo Normal:</label>
                                <p className="dato" style={{ fontWeight: 500 }}>{key.saldoNormal} GS.</p>
                              </div>
                            {
                              key.tipo === "Master" && key?.disponible >= 0 &&
                              <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                                <label className="titulo">Saldo Disponible:</label>

                                <p className="dato" style={{ fontWeight: 500 }}>{key.disponible} GS.</p>
                              </div>
                            }
                            {
                              key.tipo === "Master" && key?.disponible < 0 &&
                              <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                                <label className="titulo">Saldo Disponible:</label>

                                <p className="dato" style={{ fontWeight: 500, color: '#cb060d' }}>{key.disponible} GS.</p>
                              </div>
                            }
                            {
                              key.tipo !== "Master" && key.servicioCabal === true && key.disponible !== null &&
                              <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                                <label className="titulo">Disponible Normal:</label>
                                <p className="dato" style={{ fontWeight: 500 }}>{key.disponible} GS.</p>
                              </div>
                            }

                            {
                              key.tipo !== "Master" && key.servicioCabal === true && key.sobregiro !== null &&

                              <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                                <label className="titulo">10% Flexible:</label>
                                <p className="dato" style={{ fontWeight: 500 }}>{key.sobregiro} GS.</p>

                              </div>
                            }

                            {
                              key.tipo !== "Master" && key.servicioCabal === true && key.dispMasSobregiro !== null &&
                              <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                                <label className="titulo">Disp. Normal + 10% Flexible:</label>
                                <p className="dato" style={{ fontWeight: 500 }}>{key.dispMasSobregiro} GS.</p>
                              </div>
                            }

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 tarj" style={{ padding: 15 }}>
                    <div className="row">
                      <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                        <label className="titulo">Fecha de Pago Mínimo</label>
                        <p className="dato" style={{ fontWeight: 500 }}>{key.fechaVencPagoMin}</p>
                      </div>
                      <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                        <label className="titulo">Pago Mínimo</label>
                        <p className="dato" style={{ fontWeight: 500 }}>{key.pagoMinimo}</p>
                      </div>
                      <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                        <label className="titulo">Saldo del Plan</label>
                        <p className="dato" style={{ fontWeight: 500 }}>{key.saldoPlan}</p>
                      </div>
                      <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                        <label className="titulo">Saldo Mora</label>
                        <p className="dato" style={{ fontWeight: 500 }}>{key.saldoMora}</p>
                      </div>
                      <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                        <label className="titulo">Días de Mora</label>
                        <p className="dato" style={{ fontWeight: 500 }}>{key.diasMora}</p>
                      </div>
                      <div className="col-6 col-lg-6 col-md-12 col-xs-6">
                        <label className="titulo">Deuda Total</label>
                        <p className="dato" style={{ fontWeight: 500 }}>{key.deudaTotal}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 tarjeta-botones" style={{ padding: 15 }}>
                    <div className="row" style={{ marginBottom: 5, paddingTop: 10, textAlign: "right" }}>
                      <div className="col-md-12">
                        <ButtonLink
                          className="btn btn-cu-primary btn-sm btn-block"
                          param={key}
                          url={ConfigService.getPathById(PAGAR_TARJETA)?.url}
                          onClick={this.pagarTarjeta}>
                          <FontAwesomeIcon icon={faMoneyBill} /> Pagar
                        </ButtonLink>
                      </div>
                    </div>

                    <div className="row" style={{ marginBottom: 5, paddingTop: 5, textAlign: "right" }}>
                      {<div className="col-md-12">
                        {key.sucursal !== 81 &&
                          (key.tipo === "Master"
                            ?
                            (
                              <ButtonLink
                                className="btn btn-cu-terciary btn-sm btn-block"
                                param={key}
                                url={ConfigService.getPathByName("configurarTarjeta")?.url}
                                onClick={() => {
                                  this.configurarTarjeta(key);
                                }}>
                                <FontAwesomeIcon icon={faPencil} /> Autogestión
                              </ButtonLink>
                            )
                            :
                            (
                              <ButtonLink
                                className="btn btn-cu-terciary btn-sm btn-block"
                                param={key}
                                url={ConfigService.getPathByName("configurarTarjetaCabal")?.url}
                                onClick={() => {
                                  this.configurarTarjetaCabal(key);
                                }}>
                                <FontAwesomeIcon icon={faPencil} /> Autogestión
                              </ButtonLink>
                            ))
                        }
                      </div>}
                    </div>



                    {
                      key.sucursal !== 81 &&
                      (key.tipo === "Master" &&
                        (
                          sessionStorage.getItem('tieneToken') === 'N' ?
                            (
                              <div className="row" style={this.ocultarMenuDinamico('pinVirtual')}>
                                <div className="col-md-12">
                                  <div>

                                    <button
                                      data-toggle="modal"
                                      data-target="#modal-pin-regenerarPinVirtual"
                                      className="btn btn-cu-terciary btn-sm btn-block"
                                      // onClick={this.pinVirtualcrear('CREAR',key)}
                                      ref={btn => { this.btn = btn; }}>
                                      <FontAwesomeIcon icon={faPencil} />
                                      Regenerar Pin
                                    </button>
                                    <ModalPinTransaccional id="modal-pin-regenerarPinVirtual" onSuccess={() => { this.pinVirtualcrear('CREAR', key) }} />
                                  </div>
                                </div>
                              </div>
                            )
                            :
                            (
                              <div className="row" style={this.ocultarMenuDinamico('pinVirtual')}>
                                <div className="col-md-12">
                                  <div>
                                    <ButtonLink
                                      className="btn btn-cu-terciary btn-sm btn-block"
                                      param={key}
                                      url={ConfigService.getPathByName("crearPinVirtual")?.url}
                                      onClick={() => {
                                        this.pinVirtualcrear('CREAR', key);
                                      }}>
                                      <FontAwesomeIcon icon={faPencil} /> Regenerar Pin
                                    </ButtonLink>
                                  </div>
                                </div>
                              </div>
                            )
                        ))
                    }
                    {
                      key.sucursal !== 81 &&
                      (key.tipo === "Master" &&
                        (
                          <div className="row" style={this.ocultarMenuDinamico('pinVirtual')}>
                            <div className="col-md-12">
                              <div>
                                <ButtonLink
                                  className="btn btn-cu-terciary btn-sm btn-block"
                                  param={key}
                                  url={ConfigService.getPathByName("configurarTarjetaCabal")?.url}
                                  onClick={() => {
                                    this.pinVirtualcrear('MODIFICAR', key);
                                  }}>
                                  <FontAwesomeIcon icon={faPencil} /> Modificar Pin
                                </ButtonLink>
                              </div>
                            </div>
                          </div>
                        ))
                    }
                    <div className="row" style={{ marginBottom: 5, paddingTop: 5, textAlign: "right" }}>
                      <div className="col-md-12">
                        {
                          key.tipo === "Panal" || key.tipo === "Cabal" ?
                            <ButtonLink
                              className="btn btn-cu-quartary btn-sm btn-block"
                              url={ConfigService.getPathByName("extractoPanalCabal")?.url
                                || ConfigService.getPathByName("extractoTC")?.url}
                              param={key}
                              onClick={this.verExtracto}>
                              <FontAwesomeIcon icon={faFilePdf} /> Ver extracto
                            </ButtonLink>
                            :
                            <ButtonLink
                              className="btn btn-cu-quartary btn-sm btn-block"
                              url={ConfigService.getPathByName("extractoTarjeta")?.url}
                              param={key}
                              onClick={this.verExtracto}>
                              <FontAwesomeIcon icon={faFilePdf} /> Ver extracto
                            </ButtonLink>
                        }
                      </div>
                    </div>
                  </div>
                  <a ref={(a) => (this.modalControl = a)}
                    href="##"
                    className="pago-servicio-caja-link"
                    data-toggle="modal"
                    data-target="#modal-adicional">
                  </a>
                  <hr />
                </div>

              )
            })
        }
        <TarjetaCreditoAdicionalPopup
          idModal="modal-adicional"
          tarjetaAdicionalList={this.state.tarjetaAdicionalList}
          tarjetaTitular={this.state.tarjetaTitular}
          selectorValuePopUp={this.selectorValuePopUp} />
      </div>
    );
  }
}